module.exports = __webpack_public_path__ + "static/media/arrowRight.1d9dc21f.svg";